import React, { useState, useEffect, useContext } from "react";
import capitalizeFirstLetter from "./../Global/capitalizeFirstLetter";
import removeQueryParams from "./../Global/removeQueryParams";
import { GlobalContext } from "./../Context";
import "./Popup.scss";
import rapibacDefault from "../../../assets/img/default-rapibac.webp";
import agenciaDefault from "../../../assets/img/default-agencia.webp";
import atmDefault from "../../../assets/img/default-atm.webp";
import autobancoDefault from "../../../assets/img/default-autobanco.webp";
import ShareButton from "./../ShareButton";

function PopUp() {
  const [currentDistance, setCurrentDistance] = useState(false);
  const [currentDuration, setCurrentDuration] = useState(false);
  const globalContext = useContext(GlobalContext);

  const {
    currentPopUp,
    initialPos,
    mapsInstance,
    langcode,
    setBackButtonVisibility,
    setCurrentPopUp,
    setCurrentBranch,
    setisShareButtonClicked,
    setResultsState,
    setMarkersVisibility,
  } = globalContext;

  let { modulePath } = drupalSettings;
  let basePath = `${document.location.origin}/${modulePath}/js/dist/`;

  const distanceCallback = (response, status) => {
    if (status === "OK") {
      let distance = response.rows[0].elements[0].distance.text;
      let duration = response.rows[0].elements[0].duration.text;

      setCurrentDistance(distance);
      setCurrentDuration(duration);
    }
  };

  const branchOfficeStateClass = () => {
    if (!currentPopUp) return;

    let currentClass = "card-locations-popup__state";
    if (currentPopUp.branchScheduleState === "Abierto") {
      currentClass += " card-locations-popup__state--open";
    } else {
      currentClass += " card-locations-popup__state--close";
    }
    return currentClass;
  };

  const currentImage = () => {
    if (!currentPopUp) return;
    if (!currentPopUp.image || currentPopUp.image === null) {
      switch (currentPopUp.fieldOfficeBranchType) {
        case "AGENCIA":
        case "AGENCIAREFORMADOR":
        case "CAJASEMPRESARIALES":
          return `${basePath}/${agenciaDefault}`;
        case "AUTOBANCO":
          return `${basePath}/${autobancoDefault}`;
        case "RAPIBAC":
        case "RAPIBANCO":
        case "KIOSKO":
        case "SERVICIODECAJA":
        case "PUNTOS":
        case "EXTRA":
          return `${basePath}/${rapibacDefault}`;
        case "ATM":
        case "ATMFULL":
        case "ATMFULLCHEQUE":
        case "SUCURSALDIGITAL":
          return `${basePath}/${atmDefault}`;
        default:
          return `${basePath}/${rapibacDefault}`;
      }
    }
    return currentPopUp.image.url;
  };

  const currentIcon = () => {
    switch (currentPopUp.fieldOfficeBranchType) {
      case "AGENCIA":
      case "AGENCIAREFORMADOR":
      case "CAJASEMPRESARIALES":
        return "/modules/custom/bac_locations/js/src/assets/img/card-agencia.svg";
      case "AUTOBANCO":
        return "/modules/custom/bac_locations/js/src/assets/img/card-autobanco.svg";
      case "RAPIBAC":
      case "RAPIBANCO":
      case "KIOSKO":
      case "SERVICIODECAJA":
      case "PUNTOS":
      case "EXTRA":
        return "/modules/custom/bac_locations/js/src/assets/img/card-kiosko.svg";
      case "ATM":
      case "ATMFULL":
      case "ATMFULLCHEQUE":
      case "SUCURSALDIGITAL":
        return "/modules/custom/bac_locations/js/src/assets/img/card-atm.svg";
      default:
        return "/modules/custom/bac_locations/js/src/assets/img/card-agencia.svg";
    }
  };

  const getTaxonomyParentID = (taxonomy, depth) => {
    switch (depth) {
      case 1:
        return taxonomy.entityId;
      case 2:
        return taxonomy.parent ? taxonomy.parent.entityId : null;
      case 3:
        return taxonomy.parent && taxonomy.parent.parent ? taxonomy.parent.parent.entityId : null;
    }
  };

  const popupCtasLink = (actionType) => {
    if (!currentPopUp.geographyLocation) return;
    const areaId = getTaxonomyParentID(
      currentPopUp.geographyLocation,
      currentPopUp.geographyLocation.depthLevel
    );
    const sucursalId = currentPopUp.fieldLocation;
    switch (langcode) {
      case "es-hn":
      case "es-cr":
        return `/${langcode}/personas/visite-una-agencia?actionType=${actionType}&areaId=${areaId}&unitId=${sucursalId}`;
    }
  };

  useEffect(() => {
    if (!currentPopUp) return;

    let maps = mapsInstance;
    let branchPosition = currentPopUp.fieldCoordinates;

    if (maps.google) {
      var distance = new maps.google.maps.DistanceMatrixService();
      distance.getDistanceMatrix(
        {
          origins: [initialPos],
          destinations: [branchPosition],
          travelMode: "DRIVING",
        },
        distanceCallback
      );
    }
  }, [mapsInstance, initialPos, currentPopUp, setBackButtonVisibility]);

  useEffect(() => {
    const isOpen = !!currentPopUp;
    const map = document.querySelector(".map");

    document.body.style.overflow = isOpen ? "hidden" : "";

    if (map) {
      map.style.pointerEvents = isOpen ? "none" : "";
    }

    return () => {
      document.body.style.overflow = "";
      if (map) map.style.pointerEvents = "";
    };
  }, [currentPopUp]);

  const enableAppointmentLinks = () => {
    const countries = ["es-cr", "es-hn"];
    return countries.includes(langcode);
  };

  const appointmentsEnabledInBranch = (branch) => {
    if (branch) {
      return branch.fieldEnableBranchAppointments;
    }
    return false;
  };

  return (
    <>
      <div
        className={`card-locations-popup__opacity ${
          currentPopUp ? "card-locations-popup__opacity--show" : ""
        }`}
      ></div>
      <div
        className={`card-locations-popup ${
          currentPopUp ? "card-locations-popup--show" : ""
        }`}
      >
        <div className="card-locations-popup__heading">
          <button
            className="card-locations-popup__close"
            onClick={() => {
              setBackButtonVisibility(true);
              setMarkersVisibility(true);
              setCurrentPopUp(false);
              setCurrentBranch("");
              setisShareButtonClicked(false);
              removeQueryParams();
              setResultsState(true);
            }}
            onKeyDown={(event) => {
              if (event.keycode === 13) setCurrentPopUp(false);
            }}
          >
            Volver
          </button>
          <div className="card-locations-popup__image-overlay"/>
          <img
            src={currentImage()}
            alt={
              currentPopUp && currentPopUp.image && currentPopUp.image !== null
                ? currentPopUp.image.alt
                : "Imagen de sucursal por defecto"
            }
            className={
              currentPopUp && currentPopUp.image && currentPopUp.image !== null
                ? "card-locations-popup__image"
                : "card-locations-popup__image-default"
            }
          />
          <div className="card-locations-popup-label_header">
            {currentPopUp &&
              currentPopUp.branchScheduleState !== "NotFound" && (
                <span
                  className={
                    currentPopUp.deactivateSchedule
                      ? "card-locations-popup__state card-locations-popup__state--open"
                      : branchOfficeStateClass()
                  }
                >
                  {" "}
                  {currentPopUp.deactivateSchedule
                    ? "Abierto"
                    : currentPopUp.branchScheduleState}{" "}
                </span>
              )}
          </div>
          {currentPopUp && currentPopUp.fieldOfficeBranchType && (
            <div className="branch-type-container">
              <img
                className="branch__icon"
                src={currentIcon()}
                alt="card type icon"
              />
              <span className="card__type">
                {currentPopUp.fieldOfficeBranchType}
              </span>
            </div>
          )}
        </div>
        <div className="card-locations-popup__content">
          <div className="card-locations-popup__title">
            {currentPopUp && currentPopUp.entityLabel && (
              <h3 className="card__name">
                {currentPopUp.entityLabel}
              </h3>
            )}
            {currentPopUp && currentPopUp.entityLabel && (
              <ShareButton title={currentPopUp.entityLabel} />
            )}
          </div>
          {currentPopUp && currentPopUp.fieldCoordinates && (
            <>
              <p className="card-route">
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href={`https://www.google.com/maps/dir/?api=1&origin=${initialPos.lat}%2C${initialPos.lng}&destination=${currentPopUp.fieldCoordinates.lat}%2C${currentPopUp.fieldCoordinates.lng}&travelmode=driving`}
                  className="card-locations-popup__waze"
                >
                  Ver ruta con Google Maps
                </a>
              </p>
              <p className="card-route">
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href={`https://www.waze.com/livemap/directions?latlng=${currentPopUp.fieldCoordinates.lat}%2C${currentPopUp.fieldCoordinates.lng}&navigate=yes&zoom=17`}
                  className="card-locations-popup__waze"
                >
                  Ver ruta con Waze
                </a>
              </p>
            </>
          )}
          {currentPopUp && currentPopUp.hasElectricCharger === true && (
            <p className="card__electric-charger">
              Sucursal con estación de carga para vehículos eléctricos
            </p>
          )}
          {currentPopUp && currentPopUp.fieldAddress && (
            <p className="card__location">
              {capitalizeFirstLetter(currentPopUp.fieldAddress)}
            </p>
          )}
          {currentPopUp &&
            currentPopUp.fieldSchedule &&
            currentPopUp.fieldSchedule.finalDates &&
            currentPopUp.fieldSchedule.finalDates.length > 0 &&
            !currentPopUp.deactivateSchedule && (
              <>
                {currentPopUp &&
                  currentPopUp.fieldScheduleCounter &&
                  currentPopUp.fieldScheduleCounter.finalDates &&
                  currentPopUp.fieldScheduleCounter.finalDates.length > 0 && (
                    <h3 className="card-locations__schedule-label">
                      Horario para cajas:{" "}
                    </h3>
                  )}
                <div className="card-locations-popup__dates">
                  <div>
                    {currentPopUp.fieldSchedule.finalDates.map(
                      (date, index) => (
                        <p className="card-locations-popup__date" key={index}>
                          {date}
                        </p>
                      )
                    )}
                  </div>
                </div>
              </>
            )}
          {currentPopUp &&
            currentPopUp.fieldScheduleCounter &&
            currentPopUp.fieldScheduleCounter.finalDates &&
            currentPopUp.fieldScheduleCounter.finalDates.length > 0 &&
            !currentPopUp.deactivateSchedule && (
              <>
                {currentPopUp.fieldSchedule &&
                  currentPopUp.fieldSchedule.finalDates &&
                  currentPopUp.fieldSchedule.finalDates.length > 0 && (
                    <h3 className="card-locations__schedule-label">
                      Horario para mostrador:{" "}
                    </h3>
                  )}
                <div className="card-locations-popup__dates">
                  <div>
                    {currentPopUp.fieldScheduleCounter.finalDates.map(
                      (date, index) => (
                        <p className="card-locations-popup__date" key={index}>
                          {date}
                        </p>
                      )
                    )}
                  </div>
                </div>
              </>
            )}
          {currentPopUp &&
            (currentPopUp.principalPhone || currentPopUp.mobilePhone) &&
            !currentPopUp.deactivatePhone && (
              <div className="card-locations-popup__phones">
                <div>
                  {currentPopUp.principalPhone && (
                    <p
                      className="card-locations-popup__phone"
                      key="popup-principal-phone"
                    >
                      {currentPopUp.principalPhone}
                    </p>
                  )}
                  {currentPopUp.mobilePhone && (
                    <p
                      className="card-locations-popup__phone"
                      key="popup-mobile-phone"
                    >
                      {currentPopUp.mobilePhone}
                    </p>
                  )}
                </div>
              </div>
            )}
          {currentDuration && (
            <p className="card-locations-popup__duration">{currentDuration}</p>
          )}
          {currentDistance && (
            <p className="card-locations-popup__distance">{currentDistance}</p>
          )}
          <p className="card__time">25min - 35min</p>
          {currentPopUp && currentPopUp.aditionalInfo && (
            <p className="card-locations-popup__info">
              {currentPopUp.aditionalInfo}
            </p>
          )}
          {currentPopUp && currentPopUp.queryFieldServices && currentPopUp.queryFieldServices.length > 0 && (
            <div className="card-locations-popup__services">
              <h3 className="card-locations-popup__services__title">
                Servicios disponibles:
              </h3>
              {currentPopUp.queryFieldServices.map(
                (service, index) => (
                  <p className="card-locations-popup__service" key={index}>
                    {service.entityLabel}
                  </p>
                )
              )}
            </div>
          )}
          {enableAppointmentLinks() && appointmentsEnabledInBranch(currentPopUp) && currentPopUp ? (
            <div className="card-locations-popup__ctas">
              <a href={popupCtasLink(0)}>Obtener tiquete</a>
              <a href={popupCtasLink(1)}>Agendar cita</a>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
}

export default PopUp;
